import { createSlice } from "@reduxjs/toolkit";

const platformRoleSlice = createSlice({
    name: "platformRole",
    initialState: '',
    reducers: {
        setPlatformRole(state, action) {
            return action.payload;
        },
    },
});

export const { setPlatformRole } = platformRoleSlice.actions;
export default platformRoleSlice.reducer;